import styled from 'styled-components';

const InputText = styled.input`
  padding: ${({ theme }) => theme.spacing.baseUnit};
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: ${({ theme }) => theme.spacing.baseUnit};
  border: 1px solid
    ${({ theme, hasError }) =>
      hasError ? theme.colors.orange : theme.colors.white};
  width: 100%;
`;

export default InputText;
